<template>
  <div class="kefu">
    <el-page-header @back="$router.back()" content="意见反馈"></el-page-header>
    <div class="main" style="margin-top: 30px;">
      <el-form v-if="type === 0" label-width="80px">
        <el-form-item label="邮箱">
          <el-input v-model="form.fankui_user" placeholder="请输入你的邮箱，便于我们回复"></el-input>
        </el-form-item>
        <el-form-item label="反馈">
          <el-input type="textarea" :rows="10" v-model="form.fankui_content" placeholder="请输入反馈的内容"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">确定</el-button>
          <el-button @click="$router.back()">取消</el-button>
        </el-form-item>
      </el-form>
      <div v-else style="text-align: center; padding: 60px 0;">
        <el-button type="success" icon="el-icon-check" circle size="medium"></el-button>
        <h3 style="margin: 16px 0 8px;">反馈成功</h3>
        <p style="color: #999; font-size: 14px;">感谢您的反馈，我们会尽快做出处理，并将结果发送到您的邮箱</p>
        <el-button style="margin-top: 20px;" @click="$router.push('/')">返回首页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { createFankui } from '@/api'

export default {
  name: 'Fankui',
  data() {
    return { type: 0, form: { fankui_user: '', fankui_content: '' } }
  },
  methods: {
    submit() {
      if (!this.form.fankui_user || !this.form.fankui_content) {
        this.$message.error('请填写完整信息')
        return
      }
      createFankui(this.form).then(() => {
        this.type = 1
      })
    }
  }
}
</script>
